import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmptyState.css';

function EmptyState({ filterActive = false, onClearFilter = null }) {
  const { t } = useTranslation('notifications');

  const title = filterActive
    ? t('notifications.filter_empty.title')
    : t('notifications.placeholder.title');
  const description = filterActive
    ? t('notifications.filter_empty.description')
    : t('notifications.placeholder.description');

  return (
    <div className="notifications-list">
      <div className="notifications-empty-state">
        <h2>{title}</h2>
        <p>{description}</p>
        {filterActive && onClearFilter ? (
          <button
            type="button"
            className="notifications-empty-state__clear-filter"
            onClick={onClearFilter}
          >
            {t('notifications.filter_empty.clear')}
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default EmptyState;
